import { useToast } from "@chakra-ui/react";
import { getCurrentSubscription } from "@syla/shared/types/helpers/subscriptions";
import { useCallback, useState } from "react";
import { errorToastOptions } from "../../components/molecules/errorToastOptions";
import { getFullPageUrl } from "../../helper/getFullPageUrl";
import { useCurrentAccountStore } from "../../store/currentAccountStore";
import { useGlobalVariablesStore } from "../../store/globalVariablesStore";
import { Subscription } from "../../types/plans/subscription";
import { stripePurchaseOrUpgrade } from "../stripePurchaseOrUpgrade";
import { Plan } from "./Plan";

export function useUnlockPlanAction({
  subscriptions,
}: {
  subscriptions: Subscription[] | undefined;
}) {
  const errorToast = useToast(errorToastOptions);
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);
  const [isWorking, setIsWorking] = useState(false);

  const currentSubscription = getCurrentSubscription(subscriptions ?? []);

  const selectedFinancialYear = useGlobalVariablesStore(
    (state) => state.selectedFinancialYear,
  );
  const unlockPlanAction = useCallback(
    async (plan: Plan) => {
      try {
        setIsWorking(true);
        await stripePurchaseOrUpgrade({
          accountId,
          successUrl: getFullPageUrl(location),
          financialYear: selectedFinancialYear?.value,
          stripeSubscriptionId: currentSubscription?.stripeSubscriptionId,
          plan,
        });
      } catch (error) {
        errorToast({
          title: "Error unlocking plan",
          description: `An unexpected error occurred. Please try again later.`,
        });
        setIsWorking(false);
        return;
      }
    },
    [
      accountId,
      currentSubscription?.stripeSubscriptionId,
      errorToast,
      selectedFinancialYear?.value,
    ],
  );

  return {
    isWorking,
    unlockPlanAction,
  };
}
